import { DataBean } from "../DataBean";

export class PlanMaintenanceItems extends DataBean {

  public async getPlanMaintenanceItemsCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getPlanMaintenanceItemsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQuantityPlanMaintenanceItemsByArea(IDPlanMaintenanceArea: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.DataBean_getQuantityPlanMaintenanceItemsByArea_Number",
      [IDPlanMaintenanceArea]
    );
  }

  public async getPlanMaintenanceItemsRender(page: number, rows: number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getPlanMaintenanceItemsRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deletePlanMaintenanceItems(idplanmaintenanceitems: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deletePlanMaintenanceItems_Number",
      [idplanmaintenanceitems]
    );
  }


  public async updatePlanMaintenanceItems(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.PlanMaintenanceItems_updatePlanMaintenanceItems_com.orange.finance.processcontract.bean.PlanMaintenanceItems",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.PlanMaintenanceItems",
        },
      ]
    );
  }
}
